import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { ButtonPadraoComponent } from '../../../../shared/components/button-padrao/button-padrao.component';
import { DatePipe, NgClass } from '@angular/common';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { DisparoAutomaticoModel } from '../../../../shared/model/disparo-automatico/disparo-automatico.model';
import { DisparoAutomaticoService } from '../../../../shared/service/disparo-automatico.service';
import { MatTooltip } from '@angular/material/tooltip';
import { TabelaSkeletonComponent } from '../../../../shared/components/tabela-skeleton/tabela-skeleton.component';
import { Subscription, debounceTime, distinctUntilChanged } from 'rxjs';
import { SocketService } from '../../../../shared/service/socket.service';
import { DisparoAtualizacaoSocket } from '../../../../shared/model/socket/disparo-atualizacao-socket.model';
import { DisparoInfosAtualizacaoSocket } from '../../../../shared/model/socket/disparo-infos-atualizacao-socket.model';
import { environment } from '../../../../../../environments/environment';
import { AuthService } from '../../../../shared/service/auth.service';
import { DomSanitizer } from '@angular/platform-browser';
import { MsgService } from '../../../../shared/service/msg.service';
import { MatDialog } from '@angular/material/dialog';
import { ModalConfirmacaoComponent } from '../../../../shared/modais/modal-confirmacao/modal-confirmacao.component';
import { PaginatorComponent } from '../../../../shared/components/paginator/paginator.component';
import { PageEvent } from '@angular/material/paginator';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { RelatorioDisparoComponent } from '../../../../relatorio-disparo/relatorio-disparo/relatorio-disparo.component';
import { classeStatusDisparo } from '../../../../shared/model/disparo-automatico/status-disparo.util';
import { ProgramacaoDisparoService } from '../../../../shared/service/programacao-disparo.service';
import { ProgramacaoDisparoModel } from '../../../../shared/model/disparo-automatico/programacao-disparo.model';
import { Router } from '@angular/router';
import { ModalLogRotinaComponent } from '../../../../shared/modais/modal-log-rotina/modal-log-rotina.component';
import { FormFieldComponent } from '../../../../shared/components/form-field/form-field.component';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import {
  DisparoAutomaticoFiltro,
  FILTRO_RECORRENCIA_SESSION_KEY,
} from '../../../../shared/model/disparo-automatico/disparo-automatico-filtro.model';
import { ModalFiltroDisparoComponent } from '../modal-filtro-disparo/modal-filtro-disparo.component';
import { MethodsUtils } from '../../../../shared/util/methods.utils';

@Component({
  selector: 'app-tabela-disparo-automatico',
  standalone: true,
  imports: [
    ButtonPadraoComponent,
    DatePipe,
    MatTooltip,
    MatTableModule,
    NgClass,
    TabelaSkeletonComponent,
    PaginatorComponent,
    MatMenuModule,
    MatButtonModule,
    FormFieldComponent,
    ReactiveFormsModule,
  ],
  templateUrl: './tabela-disparo-automatico.component.html',
  styleUrl: './tabela-disparo-automatico.component.css',
})
export class TabelaDisparoAutomaticoComponent implements OnInit {

  @Output() disparoAutomaticoSelecionado = new EventEmitter<DisparoAutomaticoModel>();
  @Output() abrirCriacao = new EventEmitter<boolean>();

  @Input() ehMobile?: boolean;
  @Input() isHml?: boolean;
  @Input() statusGroup: 'DISPAROS' | 'PROGRAMACOES' = 'DISPAROS';
  @Input() textoVazio = 'Nenhum disparo encontrado.';
  @Input() permitirCriacao = true;
  @Input() programacaoId?: number;

  readonly classeStatusDisparo = classeStatusDisparo;
  readonly STATUS_BUSCANDO_BASE = 'Buscando base';
  private readonly STATUS_LIMITE_ATINGIDO = 'Limite atingido';
  private readonly STATUS_PROCESSANDO = 'Processando';

  estaBuscandoBase(element?: DisparoAutomaticoModel | null): boolean {
    return element?.status === this.STATUS_BUSCANDO_BASE;
  }

  statusParaExibicao(elemento?: DisparoAutomaticoModel | null): string {
    if (
      elemento?.status === this.STATUS_LIMITE_ATINGIDO &&
      (elemento.infos?.numEmProcessamento ?? 0) > 0
    ) {
      return this.STATUS_PROCESSANDO;
    }
    return elemento?.status ?? '';
  }

  enviadosAtivo(elemento?: DisparoAutomaticoModel | null): boolean {
    return (
      elemento?.status === 'Enviado' ||
      elemento?.status === this.STATUS_PROCESSANDO ||
      elemento?.status === this.STATUS_LIMITE_ATINGIDO
    );
  }

  disparoAutomaticoList: DisparoAutomaticoModel[] = [];
  disparoAutomaticoTable = new MatTableDataSource<DisparoAutomaticoModel>();
  disparosCarregado = false;

  displayedColumns: string[] = ['acoes', 'id', 'status', 'titulo', 'numero', 'dataEnvio', 'tipoEnvio', 'setor', 'investimento', 'contatos', 'validos', 'enviados', 'recebidos', 'lidos', 'porcentagemAlcance', 'interacao', 'porcentagemInteracao', 'porcentagemRespostaPesquisa', 'fluxo', 'usuEnvio', 'integracao'];

  private readonly displayedColumnsProgramacoes: string[] = ['acoes', 'id', 'status', 'titulo', 'numero', 'dataEnvio', 'tipoEnvio', 'quantidadeEnvios', 'erros', 'investimentoAcumulado', 'template', 'fluxo', 'etapa', 'usuEnvio', 'integracao'];

  private chatSubscriptionMap = new Map<string, Subscription>();

  page = 0;
  limit = 10;
  length = 0;
  filtro = new DisparoAutomaticoFiltro();
  pesquisaControl = new FormControl('', { nonNullable: true });

  private readonly disparoAutomaticoService = inject(DisparoAutomaticoService);
  private readonly programacaoDisparoService = inject(ProgramacaoDisparoService);
  private readonly socketService = inject(SocketService);
  private readonly authService = inject(AuthService);
  private readonly domSanitizer = inject(DomSanitizer);
  private readonly msgService = inject(MsgService);
  private readonly dialog = inject(MatDialog);
  private readonly router = inject(Router);

  ngOnInit() {
    if (this.statusGroup === 'PROGRAMACOES') {
      this.displayedColumns = this.displayedColumnsProgramacoes;
    }
    this.filtro = this.criarFiltroPadrao();
    this.pesquisaControl.valueChanges
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe((titulo) => {
        this.filtro.titulo = titulo;
        this.page = 0;
        this.buscarDisparoAutomatico();
      });
    this.buscarDisparoAutomatico();
    this.iniciarInscricaoDisparo();
  }

  private iniciarInscricaoDisparo() {
    this.chatSubscriptionMap.forEach((subscription) =>
      subscription.unsubscribe(),
    );
    this.chatSubscriptionMap.clear();

    const statusSub = this.socketService.escutarAtualizacaoDisparo().subscribe({
      next: (atualizacao) => this.aplicarAtualizacaoStatus(atualizacao),
    });
    this.chatSubscriptionMap.set('disparo', statusSub);

    const infosSub = this.socketService.escutarAtualizacaoInfosDisparo().subscribe({
      next: (atualizacao) => this.aplicarAtualizacaoInfos(atualizacao),
    });
    this.chatSubscriptionMap.set('disparo-infos', infosSub);
  }

  private aplicarAtualizacaoStatus(atualizacao: DisparoAtualizacaoSocket): void {
    const disparo = this.disparoAutomaticoList.find((item) => item.id === atualizacao.disparoId);
    if (!disparo) return;
    disparo.status = atualizacao.status;
    this.destacarLinha(disparo);
    this.disparoAutomaticoTable.data = [...this.disparoAutomaticoList];
  }

  private aplicarAtualizacaoInfos(atualizacao: DisparoInfosAtualizacaoSocket): void {
    const disparo = this.disparoAutomaticoList.find((item) => item.id === atualizacao.disparoId);
    if (!disparo) return;
    disparo.infos = { ...(disparo.infos ?? {}), ...atualizacao.infos };
    if (atualizacao.custoDisparo !== undefined) disparo.custoDisparo = atualizacao.custoDisparo;
    if (atualizacao.moedaCusto !== undefined) disparo.moedaCusto = atualizacao.moedaCusto;
    this.destacarLinha(disparo);
    this.disparoAutomaticoTable.data = [...this.disparoAutomaticoList];
  }

  private destacarLinha(disparo: DisparoAutomaticoModel): void {
    disparo.atualizadoAgora = true;
    setTimeout(() => disparo.atualizadoAgora = false, 900);
  }

  buscarDisparoAutomatico() {
    this.disparosCarregado = true;
    if (this.statusGroup === 'PROGRAMACOES') {
      this.programacaoDisparoService
        .buscarProgramacoes(this.page, this.limit, this.filtro)
        .subscribe({
          next: (res) =>
            this.atualizarTabela(
              res.content.map((item) => this.paraLinhaProgramacao(item)),
              res.totalElements,
            ),
          complete: () => (this.disparosCarregado = false),
        });
      return;
    }

    this.disparoAutomaticoService.buscarDisparosAutomaticos(this.page, this.limit, this.statusGroup, undefined, this.filtro)
      .subscribe({
        next: (res) => {
          this.atualizarTabela(res.content, res.totalElements);
        },
        complete: () => (this.disparosCarregado = false),
      });
  }

  private atualizarTabela(conteudo: DisparoAutomaticoModel[], total: number): void {
    this.length = total;
    this.disparoAutomaticoList = conteudo;
    this.disparoAutomaticoTable.data = conteudo;
  }

  private paraLinhaProgramacao(item: ProgramacaoDisparoModel ): DisparoAutomaticoModel {
    const linha = Object.assign(new DisparoAutomaticoModel(), item.disparo ?? {});
    linha.id = item.programacaoId ?? item.disparoId ?? item.id;
    linha.programacaoId = item.programacaoId;
    linha.ehProgramacaoRecorrente = item.recorrente === true;
    linha.programacao = item.recorrente ? item : undefined;
    linha.status = item.status ?? linha.status;
    linha.quantidadeEnvios = item.quantidadeEnvios ?? item.enviosRealizados ?? 0;
    linha.quantidadeErros = item.quantidadeErros ?? 0;
    linha.investimentoAcumulado = item.investimentoAcumulado ?? 0;

    if (linha.ehProgramacaoRecorrente && item.proximaExecucao) {
      linha.dataEnvio = new Date(item.proximaExecucao);
    } else if (!linha.dataEnvio && linha.dataAgendamento) {
      const agendamento = new Date(linha.dataAgendamento);
      const [hora = 0, minuto = 0] = (linha.horaAgendamento ?? '')
        .split(':')
        .map(Number);
      agendamento.setHours(hora, minuto, 0, 0);
      linha.dataEnvio = agendamento;
    }
    return linha;
  }

  abrirEdicao(element: any) {
    this.disparoAutomaticoSelecionado.emit(element);
  }

  abrirReplica(element: DisparoAutomaticoModel) {
    this.disparoAutomaticoSelecionado.emit({ ...element, replicar: true });
  }

  executarAcaoPrincipal(element: DisparoAutomaticoModel): void {
    if (element.ehProgramacaoRecorrente) {
      this.verHistoricoRecorrencia(element);
      return;
    }
    if (this.estaBuscandoBase(element)) {
      this.msgService.msgInfo(
        'O disparo ainda está buscando a base de contatos. Aguarde a conclusão.',
      );
      return;
    }
    this.abrirEdicao(element);
  }

  verHistoricoRecorrencia(element: DisparoAutomaticoModel): void {
    if (element.programacaoId == null) {
      return;
    }
    sessionStorage.setItem(FILTRO_RECORRENCIA_SESSION_KEY, String(element.programacaoId));
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/disparos']),
    );
    const aba = window.open(url, '_blank');
    sessionStorage.removeItem(FILTRO_RECORRENCIA_SESSION_KEY);
    if (aba) aba.opener = null;
  }

  cancelarProgramacao(element: DisparoAutomaticoModel): void {
    if (element.programacaoId == null) {
      return;
    }
    this.dialog.open(ModalConfirmacaoComponent, {
        data: { texto: 'Deseja cancelar esta programação recorrente?' },
      })
      .afterClosed()
      .subscribe({
        next: (confirmado) => {
          if (!confirmado) {
            return;
          }
          this.programacaoDisparoService
            .cancelarProgramacao(element.programacaoId!)
            .subscribe({
              next: () => {
                this.msgService.msgSucesso('Programação recorrente cancelada!');
                this.buscarDisparoAutomatico();
              },
            });
        },
      });
  }

  cancelarItemProgramacao(element: DisparoAutomaticoModel): void {
    if (element.ehProgramacaoRecorrente) {
      this.cancelarProgramacao(element);
      return;
    }
    this.cancelarEnvios(element);
  }

  abrirLogs(element: DisparoAutomaticoModel): void {
    const data = element.ehProgramacaoRecorrente
      ? { programacaoId: element.programacaoId }
      : { disparoId: element.id };
    this.dialog.open(ModalLogRotinaComponent, {
      width: '361px',
      height: '100vh',
      position: { top: '0', right: '0' },
      data,
      panelClass: 'slide-modal',
    });
  }

  iconeTipoEnvio(tipo: string): string {
    return MethodsUtils.getIconeTipoEnvio(tipo)
  }

  obterEnvio(elemento: DisparoAutomaticoModel): string {
    if (elemento.tipoDisparo?.toLowerCase() === 'email') {
      return elemento.emailRemetente?.trim() || '-';
    }

    if (elemento.tipoDisparo?.toLowerCase() === 'sms') {
      return elemento.remetenteSms?.trim() || '-';
    }

    const conta = elemento.template?.conta;
    return conta?.numero && conta?.nome
      ? `${conta.numero} - ${conta.nome}`
      : '-';
  }

  ehEmailOuSms(tipo?: string): boolean {
    const canal = tipo?.toLowerCase();
    return canal === 'email' || canal === 'sms';
  }

  abrirFiltro(): void {
    this.dialog
      .open(ModalFiltroDisparoComponent, {
        width: '361px',
        height: '100vh',
        position: { top: '0', right: '0' },
        data: {
          filtro: this.filtro,
          statusGroup: this.statusGroup,
        },
        panelClass: 'slide-modal',
      })
      .afterClosed()
      .subscribe((resultado: DisparoAutomaticoFiltro | null) => {
        if (!resultado) return;
        resultado.titulo = this.pesquisaControl.value;
        this.filtro = resultado;
        this.page = 0;
        this.buscarDisparoAutomatico();
      });
  }

  limparFiltros(): void {
    this.filtro = this.criarFiltroPadrao(false);
    this.page = 0;
    this.programacaoId = undefined;
    if (this.pesquisaControl.value) {
      this.pesquisaControl.setValue('');
      return;
    }
    this.buscarDisparoAutomatico();
  }

  private criarFiltroPadrao(
    incluirProgramacaoInicial = true,
  ): DisparoAutomaticoFiltro {
    const filtro = new DisparoAutomaticoFiltro();
    if (incluirProgramacaoInicial && this.programacaoId != null) {
      filtro.programacoes = [
        { id: this.programacaoId, nome: `Recorrência #${this.programacaoId}` },
      ];
    }
    filtro.status =
      this.statusGroup === 'PROGRAMACOES'
        ? [
            { id: 'RECORRENTE', nome: 'Recorrente' },
            { id: 'AGENDADO', nome: 'Agendado' },
          ]
        : [
            { id: 'ENVIADO', nome: 'Enviado' },
            { id: 'EM_FILA', nome: 'Em fila' },
            { id: 'AGUARDANDO_ENVIO', nome: 'Aguardando envio' },
            { id: 'PROCESSANDO', nome: 'Processando' },
            { id: 'LIMITE_ATINGIDO', nome: 'Limite atingido' },
            { id: 'ERRO', nome: 'Erro' },
            { id: 'BUSCANDO_BASE', nome: 'Buscando base' },
            { id: 'PAUSADO', nome: 'Pausado' },
          ];
    return filtro;
  }

  gerarUrl(nomeArquivo: string, extensao: string, path: string) {
    return this.domSanitizer.bypassSecurityTrustUrl(
      `${environment.urlRepositorioClaribot}/${this.authService.getUsuarioLogado().grupo}/${path}/${nomeArquivo}.${extensao}`,
    );
  }

  cancelarEnvios(element: any) {
    this.dialog.open(ModalConfirmacaoComponent, {
        data: { texto: 'Deseja cancelar os envios dos disparos?' },
      })
      .afterClosed()
      .subscribe({
        next: (res) => {
          if (res) {
            this.disparoAutomaticoService
              .alterarStatusDisparoAutomatico('Cancelado', element.id)
              .subscribe({
                next: () => {
                  this.msgService.msgSucesso(
                    'Disparo Automático cancelado os envios!',
                  );
                  this.buscarDisparoAutomatico();
                },
              });
          }
        },
      });
  }

  handlePageEvent(e: PageEvent) {
    this.page = e.pageIndex;
    this.limit = e.pageSize;
    this.buscarDisparoAutomatico();
  }

  zerarPaginacao() {
    this.page = 0;
    this.limit = 10;
    this.length = 0;
    this.buscarDisparoAutomatico();
  }

  abrirCriacaoEmit() {
    this.abrirCriacao.emit();
  }

  formatUSD(value: number) {
    return (value ?? 0).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
    });
  }

  exportarEmPdf(disparoId: number): void {
    this.dialog.open(RelatorioDisparoComponent, {
      data: { disparoId },
      width: '100vw',
      maxWidth: '100vw',
      height: '100vh',
      maxHeight: '100vh',
      panelClass: 'relatorio-dialog',
      disableClose: false,
    });
  }
}
